import * as React from "react";
import styles from "./chat-footer.scss";
import { MdDeleteOutline } from "react-icons/md";

export const ChatFooter = ({
  clearChat,
  registerCase,
  translation,
  canActOnDraft
}: {
  clearChat: () => void, registerCase: () => void,
  translation: Record<string, string>,
  canActOnDraft: boolean
}) => (
  <div className={styles.chatFooter}>
    <button
      className={`btn btn-call-to-action ${styles.btnRegisterCase}`}
      onClick={() => registerCase()}
      disabled={!canActOnDraft}
    >
      {translation.textRegisterCase}
    </button>

    <button className={styles.clearChat} onClick={clearChat}>
      <MdDeleteOutline className={styles.clearChatIcon} />
      {translation.textClearChat}
    </button>

  </div>
);
